import { Text } from '@thanx/uikit/text'
import InfoBox from 'components/InfoBox'
import { buildTranslate } from 'locales'
import isEmpty from 'lodash/isEmpty'
import { ScheduleOverride } from 'models/OrderingConfig'
import moment from 'moment-timezone'
import React from 'react'

type PropsT = { scheduleOverrides: ScheduleOverride[] }

const t = buildTranslate('ordering_management.detail.schedule_overrides')

const COL_DATE = { width: '150px' }
const COL_HOURS = { flex: 1 }
const COL_HANDOFF = { width: '100px' }

function formatDate(dateStr: string): string {
  return moment.utc(dateStr).format('MMM D, YYYY')
}

function formatHours(hours: Array<{ open: string; close: string }>): string {
  return hours.length === 0
    ? t('closed_all_day')
    : hours.map(r => `${r.open}–${r.close}`).join(' and ')
}

function formatHandoffMode(mode: string): string {
  const key = mode.toLowerCase()
  return t(`handoff_mode.${key}`, { defaultValue: mode })
}

const Header: React.FC = () => (
  <>
    <Text.Header3 bold color="grey90">
      {t('title')}
    </Text.Header3>
    <Text.BodyText3 color="grey70" tag="p" className="mb-l">
      {t('subtitle')}
    </Text.BodyText3>
  </>
)

const ScheduleOverrides: React.FC<PropsT> = ({ scheduleOverrides }) => {
  if (isEmpty(scheduleOverrides)) {
    return (
      <div className="mb-xxl">
        <Header />
        <InfoBox type="info" content={t('infobox_content')} />
      </div>
    )
  }

  return (
    <div className="mb-xxl">
      <Header />
      <div className="d-flex px-m pb-s border-bottom-1 grey-20-border">
        <div style={COL_DATE}>
          <Text.BodyText4 bold color="grey90">
            {t('header_date')}
          </Text.BodyText4>
        </div>
        <div style={COL_HOURS}>
          <Text.BodyText4 bold color="grey90">
            {t('header_hours')}
          </Text.BodyText4>
        </div>
        <div style={COL_HANDOFF}>
          <Text.BodyText4 bold color="grey90">
            {t('header_handoff')}
          </Text.BodyText4>
        </div>
      </div>
      {scheduleOverrides.map((override, index) => (
        <div
          key={`${override.date}-${override.handoff_mode}-${index}`}
          className="d-flex px-m py-m border-bottom-1 grey-20-border"
        >
          <div style={COL_DATE}>
            <Text.BodyText4 color="grey70">
              {formatDate(override.date)}
            </Text.BodyText4>
          </div>
          <div style={COL_HOURS}>
            <Text.BodyText4 color="grey70">
              {formatHours(override.hours)}
            </Text.BodyText4>
          </div>
          <div style={COL_HANDOFF}>
            <Text.BodyText4 color="grey70">
              {formatHandoffMode(override.handoff_mode)}
            </Text.BodyText4>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ScheduleOverrides
